import { GenIcon } from '../helpers/IconBase.es.js';

const GoogleFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M21.5892 10.1817H12.0433V14.2725H17.4533C16.5892 17 14.4533 17.9092 12 17.9092C11.0496 17.9103 10.1129 17.6822 9.26942 17.2442C8.42595 16.8061 7.70058 16.1711 7.15486 15.393C6.60913 14.6148 6.25916 13.7165 6.13462 12.7743C6.01009 11.8321 6.11466 10.8737 6.43948 9.98048C6.7643 9.08728 7.29978 8.2856 8.00049 7.64347C8.70119 7.00134 9.54644 6.5377 10.4645 6.29189C11.3826 6.04608 12.3465 6.02535 13.2743 6.23145C14.2021 6.43756 15.0665 6.86443 15.7942 7.47583L18.7667 4.6425C17.5694 3.54043 16.1213 2.74719 14.548 2.33161C12.9747 1.91603 11.3238 1.89067 9.73845 2.25773C8.15313 2.62479 6.68133 3.37318 5.45079 4.43795C4.22025 5.50272 3.26814 6.85171 2.6771 8.36783C2.08605 9.88396 1.87392 11.5214 2.05912 13.1381C2.24432 14.7548 2.82125 16.3019 3.73984 17.645C4.65843 18.9882 5.89094 20.087 7.33039 20.8459C8.76984 21.6048 10.3727 22.001 12 22C17.5142 22 22.5 18.3633 21.5892 10.1817Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { GoogleFilled };
